import { FC, useEffect } from 'react';
import toast from 'react-hot-toast';

const SupportSessionNotice: FC = () => {
  useEffect(() => {
    const main = document.querySelector('#main');
    if (main?.getAttribute('data-support-session-ended') !== 'true') return;

    // Rails consumes the flash on this page load. Consume the DOM marker too,
    // so a React remount cannot announce the same sign-out a second time.
    main.removeAttribute('data-support-session-ended');
    toast('Parent session ended. You’re signed out.', {
      id: 'support-session-ended',
      duration: 5000,
      ariaProps: { role: 'status', 'aria-live': 'polite' },
      style: {
        fontSize: '14px',
        lineHeight: '20px',
        padding: '12px 16px',
        border: '1px solid #e5e7eb',
      },
    });
  }, []);

  return null;
};

export default SupportSessionNotice;
